import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { SelectInput } from "../../../components/select/select";
import { Textarea } from "../../../components/textarea";
import { StyledReceivedMessageBox, StyleSingleChatBox } from "../../../styles/support";
import { Avatar } from "@material-ui/core";

//Registration schema
const schema = yup.object().shape({
    ticketReply: yup.string().required("Ticket Reply is a required field"),
    status: yup.string().required("Status is a required field"),
});

const AdminSupportViewTicket = () => {
    const statusOptions = [
        {
            value: "open",
            label: "Open",
        },
        {
            value: "closed",
            label: "Closed",
        },
    ];

    const {
        handleSubmit,
        control,
        formState: { errors },
        register,
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
    }

    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container >
                    <MainContent>
                        <Heading>
                            Extra/Support
                        </Heading>
                        <Breadcrumb
                            crumbs={['support', 'ticket']}
                        />
                        <StyleSingleChatBox type="received">
                            <StyledReceivedMessageBox type="received" >
                                <Avatar alt="Name" src="/assets/images/avatar.jpg" sx={{ width: 32, height: 32 }} />
                                <div>
                                    <h2 className="name">Nyarko Patience</h2>
                                    <p className="ticket-reply">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque .</p>
                                    <p className="chat-time">5 mins ago</p>
                                </div>

                            </StyledReceivedMessageBox>
                        </StyleSingleChatBox>
                        <StyleSingleChatBox type="sent">
                            <StyledReceivedMessageBox type="sent">

                                <div>
                                    <h2 className="name">You</h2>
                                    <p className="ticket-reply">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                                    <p className="chat-time">5 mins ago</p>
                                </div>
                                <Avatar alt="Name" src="/assets/images/avatar.jpg" sx={{ width: 32, height: 32 }} />
                            </StyledReceivedMessageBox>
                        </StyleSingleChatBox>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <InputWrapper>
                                <Textarea
                                    id="ticketReply"
                                    type="text"
                                    placeholder="Ticket Reply"
                                    {...register("ticketReply")}
                                    error={errors.ticketReply?.message}
                                    fullWidth
                                />
                            </InputWrapper>

                            <InputWrapper>
                                <Controller
                                    control={control}
                                    name="status"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="status"
                                                type="text"
                                                label='status'
                                                placeholder="Select Status"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.status?.message}
                                                options={statusOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto', marginTop: '6rem' }}
                                responsive
                            >
                                SUBMIT
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper >
    )
}

export default AdminSupportViewTicket
